<template>
  <v-container fluid>
    <v-card
      flat
      class="custom-grey-border remove-border-radius"
      :disabled="pageLoading"
    >
      <v-card-title
        class="headline grey lighten-4"
        @click="show_content = !show_content"
      >
        <h3 class="font-weight-700 custom-headline color-custom-blue">
          <v-icon>
            {{ !show_content ? "mdi-chevron-down" : "mdi-chevron-up" }}
          </v-icon>
          Value Added Services And Customer Responsibilty
        </h3>
      </v-card-title>
      <v-expand-transition>
        <v-card-text v-show="show_content" class="p-6 font-size-16">
          <v-row dense>
            <!-- Value Added Services Card -->
            <v-col cols="12" md="6" class="py-2">
              <v-card
                flat
                outlined
                class="rounded-lg pa-4 blue lighten-5 h-100"
              >
                <div
                  class="d-flex align-center justify-space-between mb-3 pb-2 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="blue" small class="mr-2"
                      >mdi-star-circle-outline</v-icon
                    >
                    <label
                      for="added-services"
                      class="font-weight-bold font-size-16 primary--text mb-0 cursor-pointer"
                    >
                      Value Added Services
                    </label>
                  </div>
                </div>
                <editor
                  :value="addedServices"
                  @input="(val) => $emit('update:added-services', val)"
                  placeholder="Enter value added services"
                />
              </v-card>
            </v-col>

            <!-- Customer Responsibility Card -->
            <v-col cols="12" md="6" class="py-2">
              <v-card
                flat
                outlined
                class="rounded-lg pa-4 green lighten-5 h-100"
              >
                <div
                  class="d-flex align-center justify-space-between mb-3 pb-2 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="green darken-1" small class="mr-2"
                      >mdi-account-check-outline</v-icon
                    >
                    <label
                      for="customer-responsibility"
                      class="font-weight-bold font-size-16 primary--text mb-0 cursor-pointer"
                    >
                      Customer Responsibility
                    </label>
                  </div>
                </div>
                <editor
                  :value="customerResponsibility"
                  @input="(val) => $emit('update:customer-responsibility', val)"
                  placeholder="Enter customer responsibility"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";

export default {
  name: "Description",
  components: {
    editor: TinyMCE,
  },
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
    addedServices: {
      type: String,
      default: "",
    },
    customerResponsibility: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show_content: true,
    };
  },
};
</script>
